export default __webpack_public_path__ + "static/media/1_center.286f9f23.png";